module.exports = __webpack_public_path__ + "static/djangogirls2018-e97f6d37daca5331a871e6dacdd3031a.jpeg";